import {
  Core_Sex,
  DayOfWeek,
  Resource_AppointmentLocation,
  Resource_AppointmentRequestStatus,
  Resource_AppointmentStatus,
} from '../src/generated/graphql';

export const WeekDaysTitles = new Map<DayOfWeek, string>([
  [DayOfWeek.DayOfWeekMonday, 'weekday.monday'],
  [DayOfWeek.DayOfWeekTuesday, 'weekday.tuesday'],
  [DayOfWeek.DayOfWeekWednesday, 'weekday.wednesday'],
  [DayOfWeek.DayOfWeekThursday, 'weekday.thursday'],
  [DayOfWeek.DayOfWeekFriday, 'weekday.friday'],
  [DayOfWeek.DayOfWeekSaturday, 'weekday.saturday'],
  [DayOfWeek.DayOfWeekSunday, 'weekday.sunday'],
]);

export const SexTitles = new Map<Core_Sex, string>([
  [Core_Sex.SexM, 'sex.male'],
  [Core_Sex.SexW, 'sex.female'],
  [Core_Sex.SexX, 'sex.diverse'],
]);

export const AppointmentRequestStatusTitles = new Map<Resource_AppointmentRequestStatus, string>([
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusApproved,
    'appointment-request.approved',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCancelled,
    'appointment-request.cancelled',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCreated,
    'appointment-request.created',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusFulfilled,
    'appointment-request.fulfilled',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusInProposal,
    'appointment-request.in-proposal',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusSubmitted,
    'appointment-request.submitted',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusTasksPending,
    'appointment-request.tasks-pending',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusRejected,
    'appointment-request.rejected',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusProposalRejected,
    'appointment-request.proposal-rejected',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusArchived,
    'appointment-request.archived',
  ],
]);

export const AppointmentStatusTitles = new Map<Resource_AppointmentStatus, string>([
  [Resource_AppointmentStatus.AppointmentStatusBooked, 'appointment-status.booked'],
  [Resource_AppointmentStatus.AppointmentStatusCancelled, 'appointment-status.canceled'],
  [Resource_AppointmentStatus.AppointmentStatusMissed, 'appointment-status.missed'],
  [Resource_AppointmentStatus.AppointmentStatusFinished, 'appointment-status.finished'],
  [Resource_AppointmentStatus.AppointmentStatusOngoing, 'appointment-status.ongoing'],
  [Resource_AppointmentStatus.AppointmentStatusPending, 'appointment-status.pending'],
  [Resource_AppointmentStatus.AppointmentStatusReserved, 'appointment-status.reserved'],
  [Resource_AppointmentStatus.AppointmentStatusRequested, 'appointment-status.requested'],
  [Resource_AppointmentStatus.AppointmentStatusNotYetPending, 'appointment-status.not-yet-pending'],
  [Resource_AppointmentStatus.AppointmentStatusNone, 'appointment-status.none'],
]);

export const AppointmentStatusTitlesShort = new Map<Resource_AppointmentStatus, string>([
  [Resource_AppointmentStatus.AppointmentStatusBooked, 'appointment-status.booked.short'],
  [Resource_AppointmentStatus.AppointmentStatusCancelled, 'appointment-status.canceled.short'],
  [Resource_AppointmentStatus.AppointmentStatusMissed, 'appointment-status.missed.short'],
  [Resource_AppointmentStatus.AppointmentStatusFinished, 'appointment-status.finished.short'],
  [Resource_AppointmentStatus.AppointmentStatusOngoing, 'appointment-status.ongoing.short'],
  [Resource_AppointmentStatus.AppointmentStatusPending, 'appointment-status.pending.short'],
  [Resource_AppointmentStatus.AppointmentStatusReserved, 'appointment-status.reserved.short'],
  [Resource_AppointmentStatus.AppointmentStatusRequested, 'appointment-status.requested.short'],
  [
    Resource_AppointmentStatus.AppointmentStatusNotYetPending,
    'appointment-status.not-yet-pending.short',
  ],
  [Resource_AppointmentStatus.AppointmentStatusNone, 'appointment-status.none.short'],
]);

export const AppointmentRequestStatusTitlesShort = new Map<
  Resource_AppointmentRequestStatus,
  string
>([
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusApproved,
    'appointment-request.approved.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCancelled,
    'appointment-request.cancelled.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCreated,
    'appointment-request.created.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusFulfilled,
    'appointment-request.fulfilled.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusInProposal,
    'appointment-request.in-proposal.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusSubmitted,
    'appointment-request.submitted.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusTasksPending,
    'appointment-request.tasks-pending.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusRejected,
    'appointment-request.rejected.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusProposalRejected,
    'appointment-request.proposal-rejected.short',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusArchived,
    'appointment-request.archived.short',
  ],
]);

export const AppointmentLocationTitles = new Map<Resource_AppointmentLocation, string>([
  [Resource_AppointmentLocation.AppointmentLocationVideo, 'appointment-request.location.video'],
  [
    Resource_AppointmentLocation.AppointmentLocationInPerson,
    'appointment-request.location.in-person',
  ],
  [Resource_AppointmentLocation.AppointmentLocationPhone, 'appointment-request.location.phone'],
  [Resource_AppointmentLocation.AppointmentLocationNone, 'appointment-request.location.none'],
]);

export const AppointmentRequestStatusDescriptionTitles = new Map<
  Resource_AppointmentRequestStatus,
  string
>([
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusApproved,
    'appointment-request.approved.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCancelled,
    'appointment-request.cancelled.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusCreated,
    'appointment-request.created.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusFulfilled,
    'appointment-request.fulfilled.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusInProposal,
    'appointment-request.in-proposal.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusSubmitted,
    'appointment-request.submitted.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusTasksPending,
    'appointment-request.tasks-pending.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusRejected,
    'appointment-request.rejected.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusProposalRejected,
    'appointment-request.proposal-rejected.description',
  ],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusArchived,
    'appointment-request.proposal-rejected.description',
  ],
]);

export const AppointmentRequestStatusBadgeColors = new Map<
  Resource_AppointmentRequestStatus,
  [string, string]
>([
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusApproved, ['#1A518A', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusCancelled, ['#6f0404', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusCreated, ['darkgray', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusFulfilled, ['darkgreen', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusInProposal, ['#1A518A', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusSubmitted, ['#1A518A', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusTasksPending, ['#8a5a00', 'white']],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusRejected, ['#6f0404', 'white']],
  [
    Resource_AppointmentRequestStatus.AppointmentRequestStatusProposalRejected,
    ['#6f0404', 'white'],
  ],
  [Resource_AppointmentRequestStatus.AppointmentRequestStatusArchived, ['darkgray', 'white']],
]);

export const AppointmentStatusBadgeColors = new Map<Resource_AppointmentStatus, [string, string]>([
  [Resource_AppointmentStatus.AppointmentStatusBooked, ['darkgreen', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusCancelled, ['#6f0404', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusFinished, ['darkgreen', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusMissed, ['#6f0404', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusPending, ['#1A518A', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusReserved, ['#1A518A', 'white']],
  [Resource_AppointmentStatus.AppointmentStatusOngoing, ['#1A518A', 'white']],
]);

export const MonthTitles: string[] = [
  'month.january',
  'month.february',
  'month.march',
  'month.april',
  'month.may',
  'month.june',
  'month.july',
  'month.august',
  'month.september',
  'month.october',
  'month.november',
  'month.december',
];
